import axios from "axios";

export default {
  getResult: function (baseApiUrl, sokOptions) {
    var response = axios.post(baseApiUrl + "/Sok", sokOptions, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  },
  getSuggestions: function (baseApiUrl, query, sokOptions) {
    sokOptions.Query = query;
    var response = axios.post(baseApiUrl, sokOptions, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  },
  getAnswer: function (baseApiUrl, query, sokOptions) {
    sokOptions.Query = query;
    var response = axios.post(
      baseApiUrl + "/ChatCompletion/Answer?",
      sokOptions,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  },
};
